<template>
    <div class="form-dynamic-wrapper mb-2">
        <b-row class="pr-5">
            <b-col md="4">
                <b-form-group>
                    <label>Name</label>
                    <b-form-input v-model="spesifikasi.name" name="spesifikasiName" placeholder="Name" class="mr-2" required></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group>
                    <label class="radio-label">
                        <b-form-radio v-model="spesifikasi.detailInfo" value="persen">Persen</b-form-radio>
                    </label>
                    <b-input-group append="%">
                        <b-form-input v-model="spesifikasi.nominalPersen" :id="`persenDesc-${spesifikasi.index}`" name="spesifikasiNominalPersen" step="0.01" type="number" @blur="roundPersen" :disabled="spesifikasi.detailInfo == 'nominal'" required></b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-popover :target="`persenDesc-${spesifikasi.index}`" title="Catatan" triggers="focus">
                    <ul class="tooltip-content-wrapper list-popover-wrapper">
                        <li class="mb-2">
                            <span class="small-muted-persen">100%</span>  -> harga dasar (tidak ada penambahan maupun pengurangan)
                        </li>
                        <li class="mb-2">
                            <span class="small-muted-persen">110%</span>  -> Tambahan 10% dari harga barang
                        </li>
                        <li class="mb-0">
                            <span class="small-muted-persen">80%</span>  -> Potongan 20% dari harga barang
                        </li>
                    </ul>
                </b-popover>
            </b-col>
            <b-col md="4">
                <b-form-group class="radio-label">
                    <label>
                        <b-form-radio v-model="spesifikasi.detailInfo" value="nominal">Nominal</b-form-radio>
                    </label>
                    <b-input-group prepend="Rp.">
                        <b-form-input v-model="spesifikasi.nominalAngka" name="spesifikasiNominalAngka" :disabled="spesifikasi.detailInfo == 'persen'" required></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div class="form-dynamic-deleteWrapper">
            <b-button class="btn-dynamicActiveBtn" name="aktifSpesifikasi" @click="$emit('aktif', spesifikasi.index)"><i class="fa fa-plus"></i></b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'spesifikasi-non-aktif',
    props: {
        spesifikasi: { type: Object, required: true },
        length: { type: Number, required: true }
    },
    watch: {
        "spesifikasi.nominalAngka": function(newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.spesifikasi.nominalAngka = result);
        },
    },
    methods: {
        roundPersen(){
            var x = Number(this.spesifikasi.nominalPersen).toFixed(2);
            this.spesifikasi.nominalPersen = x;
        }
    }
}
</script>
